/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import jwt from '../../http/requests/auth/jwt/index.js'
//import firebase from 'firebase/app'
import 'firebase/auth'
import router from '@/router'

export default {

  // JWT
  loginJWT ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      jwt.login(payload.userDetails.email, payload.userDetails.password)
        .then(response1 => {
          window.getPrendTaCom.$http.post('login/', payload.userDetails.data)
            .then((response) => {
              localStorage.clear()
              localStorage.setItem('accessToken', response.data.token)
              window.getPrendTaCom.$http.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`
              window.getPrendTaCom.$http.defaults = JSON.parse(JSON.stringify(window.getPrendTaCom.$http.defaults))
              if (response1.data.userData) {
                if (!response.data.user.passwordChanged === true) {
                  router.push(router.currentRoute.query.to || '/Changelogin')
                } else {
                  if (response.data.user.role === 'agent') {
                    router.push(router.currentRoute.query.to || '/')
                  }
                  if (response.data.user.role !== 'agent') {
                    router.push(router.currentRoute.query.to || '/')
                  }
                }
               
                localStorage.setItem('accessToken', response.data.token)
                window.getPrendTaCom.$http.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`
                window.getPrendTaCom.$http.defaults = JSON.parse(JSON.stringify(window.getPrendTaCom.$http.defaults))

                Object.assign(response1.data.userData, response.data.user)

                // Update user details
                commit('UPDATE_USER_INFO', response1.data.userData, {root: true})

                // Set bearer accessToken in axios
                commit('SET_BEARER', response1.data.accessToken)

                resolve(response1)

              } else {

                reject({message: 'Wrong Email or Password'})

              }
             

            })
            .catch((error) => {
              reject({message: error.response.data})
            })
        })
        .catch(error => { reject(error) })
    })
  },
  registerUserJWT ({ commit }, payload) {

    const { displayName, email, password, confirmPassword } = payload.userDetails

    return new Promise((resolve, reject) => {

      // Check confirm password
      if (password !== confirmPassword) {
        reject({message: 'Password doesn\'t match. Please try again.'})
      }

      jwt.registerUser(displayName, email, password)
        .then(response => {
          // Redirect User
          router.push(router.currentRoute.query.to || '/')

          // Update data in localStorage
          localStorage.setItem('accessToken', response.data.accessToken)
          commit('UPDATE_USER_INFO', response.data.userData, {root: true})

          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },
  fetchAccessToken () {
    return new Promise((resolve) => {
      jwt.refreshToken().then(response => { resolve(response) })
    })
  }
}
